import reportErrorToBackend from '../utilities/report-error-to-backend'

export default {
  install (Vue) {
    // Vue-specific errors
    Vue.config.errorHandler = (err, vm, info) => {
      reportErrorToBackend({
        type: 'vue specific',
        message: err.message,
        stack: err.stack,
        info,
        component: vm?.$options?.name || 'anonymous'
      })
    }

    // Global JS errors
    window.onerror = (message, source, lineno, colno, error) => {
      reportErrorToBackend({
        type: 'global js error',
        message,
        stack: error?.stack || null
      })
    }

    // Promise rejections
    window.onunhandledrejection = (event) => {
      reportErrorToBackend({
        type: 'promise rejection',
        message: event.reason?.message || String(event.reason),
        stack: event.reason?.stack || null
      })
    }
  }
}
